import gql from 'graphql-tag';

export const COUNT_AVAILABLE_BED_NUMBER = gql`
  query CountAvailableBedNumber($propertyId: ID!, $filter: countAvailableBedNumberInput!) {
    countAvailableBedNumber(propertyId: $propertyId, filter: $filter) {
      count
    }
  }
`;

export const QUERY_NODE_TENDENCY = gql`
  query QueryNodeTenancy($id: ID) {
    node(id: $id) {
      ... on TenancyOption {
        id
        originId
        name
        startDate
        endDate
        rateType
        tenancyLengthOption
      }
    }
  }
`;

export const QUERY_NODE_ROOMTYPE = gql`
  query QueryNodeRoomType($id: ID) {
    node(id: $id) {
      ... on RoomType {
        id
        originId
        name
        category
        bathroomArrangement
        kitchenArrangement
      }
    }
  }
`;

export const QUERY_NODE_PROPERTY_INFO = gql`
  query QueryNodePropertyInfo($id: ID) {
    node(id: $id) {
      ... on Property {
        id
        name
        imageName
        areaUnitOfMeasurement
        contactAreaCode
        contactPhoneNumber
        contactEmailAddress
        addressLine1
        addressLine2
        postalCode
        city {
          id
          name
        }
        country {
          id
          name
        }
        roomTypes(availableForBook: true) {
          id
          originId
          name
          kitchenArrangement
          bathroomArrangement
          category
          hasPrice
        }
      }
    }
  }
`;
